module.exports = __webpack_public_path__ + "static/media/L3_3.61146243.gif";